import WorkInProgressProfilesApi from '../../../core/api/WorkInProgressAdviserProfilesApi'
import PendingProfilesApi from '../../../core/api/PendingApprovalAdviserProfilesApi'
import ContactNumberTypesApi from '../../../core/api/ContactNumberTypesApi'
import AdvisersApi from '../../../core/api/AdvisersApi'
const workInProgressProfilesApi = new WorkInProgressProfilesApi()
const advisersApi = new AdvisersApi()
const pendingAdvisersApi = new PendingProfilesApi()

import { events as blurbEvents } from '../AdviserProfileBlurbEditor/adviserProfileBlurbEditorActions'
import { events as languagesEvents } from '../AdviserProfileLanguagePreferencesEditor/adviserProfileLanguagePreferencesEditorActions'
import { events as investmentMinimumsEvents } from '../AdviserProfileInvestmentMinimumsEditor/adviserProfileInvestmentMinimumsEditorActions'
import { events as clientTypesEvents } from '../AdviserProfileClientTypesEditor/adviserProfileClientTypesEditorActions'
import { events as areasOfSpecialisationEvents } from '../AdviserProfileAreasOfSpecialisationEditor/adviserProfileAreasOfSpecialisationEditorActions'
import { events as conflictDeclarationsEvents } from '../AdviserProfileConflictDeclarationsEditor/adviserProfileConflictDeclarationsEditorActions'
import { events as educationEvents } from '../AdviserProfileEducationEditor/adviserProfileEducationEditorActions'
import { events as contactDetailsEvents } from '../AdviserProfileContactDetailsEditor/adviserProfileContactDetailsEditorActions'
import { events as picturesEditorEvents } from '../AdviserProfilePicturesEditor/adviserProfilePicturesEditorActions'
import { events as workExperienceEvents } from '../AdviserProfileWorkExperienceEditor/adviserProfileWorkExperienceEditorActions'
import {toast} from 'react-toastify'

export const events = {
  fetch: {
    fetching: 'FETCHING_ADVISER_PROFILE_CONTAINER_PROFILE',
    fetched: 'FETCHED_ADVISER_PROFILE_CONTAINER_PROFILE',
    fetchingPendingProfile: 'FETCHING_PENDING_ADVISER_PROFILE_CONTAINER_PROFILE',
    fetchedPendingProfile: 'FETCHED_PENDING_ADVISER_PROFILE_CONTAINER_PROFILE',
    contactNumberTypes: 'ADVISER_CONTACT_DETAILS_CONTACT_NUMBER_TYPES_FETCHED'
  },
  login: {
    loggingIn: 'ADVISER_PROFILE_CONTAINER_LOGGING_ADVISER_IN',
    loggedIn: 'ADVISER_PROFILE_CONTAINER_ADVISER_LOGGED_IN',
    loggedOut: 'ADVISER_PROFILE_CONTAINER_ADVISER_LOGGED_OUT',
    loginFailed: 'ADVISER_PROFILE_CONTAINER_ADVISER_LOGIN_FAILED'
  },
  edit: {
    start: 'ADVISER_PROFILE_CONTAINER_EDIT',
    stop: 'ADVISER_PROFILE_CONTAINER_EDIT_STOP',
    cancel: 'ADVISER_PROFILE_CONTAINER_EDIT_CANCEL'
  },
  submit: {
    submitting: 'ADVISER_PROFILE_SUBMITTING',
    submitted: 'ADVISER_PROFILE_SUBMITTED'
  },
  set: {
    adviserId: 'ADVISER_PROFILE_ADVISER_ID_CHANGED',
    showProfileLockedModal: 'SHOW_ADVISER_PROFILE_IS_LOCKED',
    hideProfileLockedModal: 'HIDE_ADVISER_PROFILE_IS_LOCKED'
  }
}

const contactNumberTypesApi = new ContactNumberTypesApi()

const { fetch, login, edit, submit, set } = events

export const actions = {
  set: {
    adviserId: (adviserId) => ({
      type: set.adviserId,
      adviserId
    }),
    showProfileLockedModal: () => ({
      type: set.showProfileLockedModal
    }),
    hideProfileLockedModal: () => ({
      type: set.hideProfileLockedModal
    })
  },
  login: {
    logAdviserOut: () => ({
      type: login.loggedOut
    }),
    logAdviserIn: (adviserId, agToken) => {
      const api = advisersApi
      const request = api.login(adviserId, agToken)

      return (dispatch) => {
        dispatch({ type: login.loggingIn, adviserId })
        request.then(function (response) {
          dispatch(api.handleResponse(login.loggedIn, response))
        }).catch(function () {
          // A blocked/blacklisted adviser makes /login return 400. Surface it as a message
          // instead of leaving the editor stuck on the loading spinner.
          dispatch({ type: login.loginFailed })
        })
      }
    }
  },
  fetch: {
    fetch: (adviserId) => {
      const api = workInProgressProfilesApi
      const request = api.getWorkInProgressAdviserProfile(adviserId)

      return (dispatch) => {
        dispatch({ type: fetch.fetching, adviserId })
        request.then(function (response) {
          dispatch(api.handleResponse(fetch.fetched, response))
        })
      }
    },
    contactNumberTypes: () => {
      const request = contactNumberTypesApi.fetchingContactNumberTypes()

      return (dispatch) => {
        request.then(response => {
          dispatch(contactNumberTypesApi.handleResponse(fetch.contactNumberTypes, response))
        })
      }
    },
    fetchPendingProfile: (adviserId) => {
      const api = pendingAdvisersApi
      const request = api.getPendingApprovalProfile(adviserId)

      return (dispatch) => {
        dispatch({ type: fetch.fetchingPendingProfile, adviserId })

        request.then(function (response) {
          dispatch(api.handleResponse(fetch.fetchedPendingProfile, response))
        })
      }
    }
  },
  submit: {
    submitProfile: (profile) => {
      const api = workInProgressProfilesApi
      const request = api.updateWorkInProgressAdviserProfile(profile.adviserId, profile)

      return (dispatch) => {
        dispatch({ type: submit.submitting })
        request.then(function (response) {
          toast.success('Profile Saved')
          // The submit.submitted reducer case ignores the payload, so don't dispatch the raw
          // fetch Response (it tripped RTK's non-serializable-value check).
          dispatch({ type: submit.submitted })
        }).catch(function (error) {
          // The save request itself may have succeeded (the success toast is shown above);
          // guard the response-handling path so a post-save error (e.g. a large profile
          // image payload) can't crash the editor or leave it stuck in a submitting state.
          console.error('Profile save failed after submission:', error && error.message)
          dispatch({ type: submit.submitted })
        })
      }
    }
  },
  edit: {
    editAll: () => {
      var events = [
        conflictDeclarationsEvents.edit.start,
        investmentMinimumsEvents.edit.start,
        areasOfSpecialisationEvents.edit.start,
        clientTypesEvents.edit.start,
        languagesEvents.edit.start,
        contactDetailsEvents.edit.contactNumber.start,
        blurbEvents.edit.start,
        picturesEditorEvents.edit.start,
        edit.start
      ]

      return (dispatch) => {
        events.forEach((event) => {
          dispatch({
            type: event
          })
        })
      }
    },
    cancelAll: () => {
      var events = [
        blurbEvents.edit.cancel,
        languagesEvents.edit.cancel,
        investmentMinimumsEvents.edit.cancel,
        clientTypesEvents.edit.cancel,
        areasOfSpecialisationEvents.edit.cancel,
        conflictDeclarationsEvents.edit.cancel,
        edit.cancel
      ]

      return (dispatch) => {
        events.forEach((event) => {
          dispatch({
            type: event
          })
        })
      }
    },
    stopAll: () => {
      var events = [
        blurbEvents.edit.stop,
        languagesEvents.edit.stop,
        investmentMinimumsEvents.edit.stop,
        conflictDeclarationsEvents.edit.stop,
        picturesEditorEvents.edit.stop,
        educationEvents.edit.stop,
        contactDetailsEvents.edit.contactNumber.stop,
        workExperienceEvents.edit.stop,
        edit.stop
      ]

      return (dispatch) => {
        events.forEach((event) => {
          dispatch({type: event})
        })
      }
    }
  }
}
